import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ColumnLeft = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          clipRule="evenodd"
          d="M8.5 2a.5.5 0 0 0-1 0v2.5H5a.5.5 0 0 0 0 1h2.5V8a.5.5 0 0 0 1 0V5.5H11a.5.5 0 0 0 0-1H8.5V2Zm-5.293 9.5 2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.207 10.5H14a.5.5 0 0 1 0 1H3.207Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ColumnLeft
